<template>
	<svg
		height="20"
		width="20"
		viewBox="-8 0 55 35"
		preserveAspectRatio="xMidYMid meet"
		@click.stop="onClick"
	>
    <defs></defs>
    <g
		stroke="none"
		stroke-width="1"
		fill="none"
		fill-rule="evenodd"
	>
        <g
			transform="translate(-1138.000000, -189.000000)"
			fill="#FF6600"
			:style="`fill:${!!active ? globalColors.primary : 'white'};stroke:${globalColors.primary};stroke-width: 0.5rem;`"
		>
            <g
				transform="translate(1138.000000, 189.000000)"
			>
                <path
					class="heart-path"
					d="M28.279875,0 C24.955125,0 21.6425625,1.57612185 19.5,4.13086538 C17.3574375,1.57612185 14.044875,0 10.720125,0 C4.684875,0 0,4.7259067 0,10.8140154 C0,18.2962912 6.6275625,24.3966942 16.7675625,33.4452565 L19.5,36 L22.2324375,33.4452565 C32.1725625,24.1950686 39,18.0946657 39,10.8140154 C39,4.7259067 34.315125,0 28.279875,0 Z"
				></path>
            </g>
        </g>
    </g>
</svg>
</template>
<script>

function onClick() {
	this.$emit('click');
}

export default {
	name: 'heart-svg',
	methods: {
		onClick,
	},
	props: {
		active: {
			default: 0,
			type: [Number, String],
		},
	},
};
</script>
<style lang="scss" scoped>

	.heart-path {
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// heartSvg.vue?463b88f4